module.exports = __webpack_public_path__ + "img/lote-primeiro.878ef469.jpg";